import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import { getConcatClickTrackingAttributes } from "@grandvisionhq/svc-tealium/utils";
import { handleHrefClick } from "../../../../SiteNav/SiteNavMobile/helpers.js";
/* empty css                  */
const SubMenuLinks = ({
  items,
  className,
  level = 1,
  ariaLabel,
  parentTealiumAttributes
}) => /* @__PURE__ */ React.createElement(
  "ul",
  {
    className: classnames(
      "site-nav-mobile-submenu__items",
      `site-nav-mobile-submenu__level-${level}`
    ),
    "aria-label": ariaLabel
  },
  items.map((item) => {
    if (!item.label) {
      return null;
    }
    let href = "#";
    if (item.link && item.link.href) {
      href = item.link.href;
    }
    if (item.parameters && item.parameters.queryString && item.parameters.queryString.length) {
      href += item.parameters.queryString;
    }
    let action;
    if (item.parameters && item.parameters.action) {
      action = item.parameters.action;
      href = "";
    }
    const icon = item?.parameters?.icon || "";
    const classes = classnames(
      "site-nav-mobile-submenu__item",
      item.link?.active && "site-nav-mobile-submenu__item--active",
      icon && "site-nav-mobile-submenu__item-with-icon",
      className
    );
    const tealiumAttributes = getConcatClickTrackingAttributes(
      item.label,
      parentTealiumAttributes
    );
    return /* @__PURE__ */ React.createElement("li", { className: classes, key: item.label }, action && !href && /* @__PURE__ */ React.createElement("button", { className: "site-nav-mobile-submenu__link", onClick: action }, icon ? /* @__PURE__ */ React.createElement("span", { className: "site-nav-mobile-submenu__icon" }, /* @__PURE__ */ React.createElement(Icon, { name: icon })) : null, item.label), href && /* @__PURE__ */ React.createElement(
      "a",
      {
        className: "site-nav-mobile-submenu__link",
        onClick: handleHrefClick,
        href,
        "data-t": item.parameters?.testId ? `submenu-link-${item.parameters.testId}` : void 0,
        ...tealiumAttributes
      },
      icon ? /* @__PURE__ */ React.createElement("span", { className: "site-nav-mobile-submenu__icon" }, /* @__PURE__ */ React.createElement(Icon, { name: icon })) : null,
      item.label
    ), item.childMenuItems?.length ? /* @__PURE__ */ React.createElement(
      SubMenuLinks,
      {
        items: item.childMenuItems,
        level: 2,
        parentTealiumAttributes: tealiumAttributes
      }
    ) : null);
  })
);
export {
  SubMenuLinks as default
};
//# sourceMappingURL=SubMenuLinks.js.map
